module.exports = __webpack_public_path__ + "static/media/climbing_camping_matterhorn.6e3ceec8.jpg";